// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3636": "dbfc89bc","4826": "940cb052","7916": "1d381851",}[chunkId] + ".css"
}